import { IconGmail, IconOutlook } from '@folio/components';

export function ProviderLogo({ type }: { type: string }) {
  return type === 'gmail' ? (
    <IconGmail className="size-7 shrink-0 object-contain" />
  ) : (
    <IconOutlook className="size-7 shrink-0 object-contain" />
  );
}
